import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { api_url } from "../../../../../../constants";
import FormGenerator from "../../../../../../Components/FormGenerator";
import { SetGdpr, UpdateGdprError } from "./GdprActions";

// const theme = createMuiTheme({
//   overrides: {
//     MuiFormControl: {
//       root: {
//         width: "100%",
//       },
//     },
//   },
// });

export default function Gdpr(props) {
  const dispatch = useDispatch();
  const globaluserData = useSelector((state) => state.commonReducer);
  const userRole = globaluserData?.role;
  const [feildIsMandatory, setFeildIsMandatory] = useState(userRole==="admin");
  useEffect(() => {
    if (userRole === "admin") {
      setFeildIsMandatory(true);
    }else{
      setFeildIsMandatory(false);
    }
  }, []);

  const {
    consent_status,
    consent_expiry_date,
    consent_terms,
    lawful_bia_id,
    purposes,
    contact_status,
  } = useSelector((state) => state.gdprReducer.data);
  const reducerData = useSelector((state) => state.gdprReducer.data);
  const purposesSelector = useSelector(
    (state) => state.commonReducer.employeeDropdowns.purposes
  );
  const {
    lawful_bia,
    contact_statuses,
    expertise_areas,
    diagnostic_tools,
    language_lists,
    client_types,
  } = useSelector((state) => state.commonReducer.employeeDropdowns);

  const errors = useSelector((state) => state.gdprReducer.errors);
console.log(errors,"gdpr errors");
  const handleInputChange = (value, index, type) => {
    props.setSomeChangeDetected(true)
    const updatedForm = formInput;
    if (!type) {
      updatedForm[index]["value"] = value;
    } else {
      updatedForm[index][type] = value;
    }
    setFormInput(updatedForm);
    const formData = {};
    formInput.forEach((item) => {
      if (item.value || item.inputValue || item.selectValue) {
        item.value && (formData[item.name] = item.value);
        item.inputValue && (formData[item.inputName] = item.inputValue);
        item.selectValue && (formData[item.selectName] = item.selectValue);
        dispatch(SetGdpr(formData));
      }
    });
    console.log(updatedForm[index].name,"gdpr errors")
    dispatch(UpdateGdprError(updatedForm[index].name));
  };

  // useEffect(() => {
  //   if (!contact_status) {
  //     dispatch(SetGdpr({ contact_status: 'Not applicable' }));
  //   }
  // }, [contact_status, dispatch])

  const formArray = [
    {
      componentType: "select",
      label:feildIsMandatory? "Consent status*":"Consent status",
      helperText: errors && errors.consent_status && "Please Yes or No",
      name: "consent_status",
      value: consent_status,
      placeholder: "Select yes or no",
      selectOptions: [
        { id: "Yes", value: "Yes", name: "Yes" },
        { id: "No", value: "No", name: "No" },
      ],
      handleChange: handleInputChange,
      errors:feildIsMandatory&& errors.consent_status
    },
    {
      componentType: "datePicker",
      required: true,
      label: feildIsMandatory ? "Consent expiry date*" : "Consent expiry date",
      name: "consent_expiry_date",
      value: consent_expiry_date,
      handleChange: handleInputChange,
      helperText:errors && errors.consent_expiry_date ? "Please enter a Date":"",
      errors:feildIsMandatory&& errors.consent_expiry_date
    },
    {
      componentType: "input",
      type: "text",
      label: feildIsMandatory ? "Consent terms *" : "Consent terms",
      helperText:errors && errors.consent_terms ? "Please enter a Consent Terms":"",
      name: "consent_terms",
      multiline: true,
      placeholder: "Consent terms",
      handleChange: handleInputChange,
      value: consent_terms,
      errors:feildIsMandatory&& errors.consent_terms
    },
    {
      componentType: "SelectSpecific",
      label: feildIsMandatory ? "Lawful bias*" : "Lawful bias",
      helperText: errors && errors.lawful_bia_id && "Please select Lawful Bias",
      name: "lawful_bia_id",
      id: "lawful_bia_id",
      value: lawful_bia_id,
      placeholder: "Select lawful bias",
      selectOptions: lawful_bia,
      // selectOptions: [
      //   { id: 0, value: "Consent", name: "Consent" },
      //   { id: 1, value: "Contractual necessity", name: "Contractual necessity" },
      //   { id: 1, value: "Legal Obligation", name: "Legal Obligation" },
      //   { id: 1, value: "Legitimate interest", name: "Legitimate interest" },
      //   { id: 1, value: "Public Interest", name: "Public Interest" },
      //   { id: 1, value: "Vital Interests", name: "Vital Interests" },
      // ],
      handleChange: handleInputChange,
      dropDown: "LawfulBium",
      field_name: "value",
      errors:feildIsMandatory&& errors.lawful_bia_id
      // componentType: "SelectSpecific",
      // label: "Ownership",
      // name: "ownership_id",
      // id: "ownership_id",
      // value: ownership_id,
      // placeholder: "Select ownership",
      // selectOptions: ownerships,
      // handleChange: handleInputChange,
      // dropDown: "Ownership",
      // field_name: "ownership",
    },
    {
      componentType: "multiSelectChip",
      label:feildIsMandatory? "Purposes*":"Purposes",
      name: "purposes",
      placeholder: "Select purposes",
      itemArr: purposesSelector,
      // id: "purposes",
      value: purposes,
      handleChange: handleInputChange,
      dropDown: "Purpose",
      field_name: "purpose",
      errors:feildIsMandatory&& errors.purposes,
      helperText:errors && errors.purposes ? "Please select purposes":""
    },
    // {
    //   componentType: "CustomSelectMulti",
    //   label: "Purposes*",
    //   name: "purposes",
    //   placeholder: "Select Purpose",
    //   itemArr: purposesSelector,
    //   id: "purposes",
    //   selectOptions: purposes,
    //   helperText: errors && errors.purposes && "Please Select Purposes",
    //   value: [],
    //   reducerData: reducerData,
    //   section: "gdpr",
    //   // dropDown: "BusinessUnitList",
    //   // field_name: "department",
    // },
    // {
    //   componentType: "MultipleSelect",
    //   label: feildIsMandatory ? "Purposes*" :  "Purposes",
    //   name: "purposes",
    //   value: purposes,
    //   placeholder: "Select Purposes",
    //   selectOptions: purposesSelector,
    //   // apiVariable: "purposes",
    //   handleChange: handleInputChange,
    //   helperText: errors && errors.purposes && "Please select a Purposes",
    //   dropDown:'Purpose',
    //   field_name:'purpose',
    // },
    {
      componentType: "select",
      label: feildIsMandatory ? "Contact status*" : "Contact status",
      helperText:
        errors && errors.contact_status && "Please select Contact Status",
      name: "contact_status",
      value: contact_status || "Not applicable",
      placeholder: "Select contact status",
      selectOptions: contact_statuses,
      // selectOptions: [
      //   { id: 0, value: "do_not_contact", name: "do_not_contact" },
      //   { id: 1, value: "do_not_mailshot", name: "do_not_mailshot" },
      // ],
      handleChange: handleInputChange,
      errors:feildIsMandatory&& errors.contact_statuses
    },
  ];

  const [formInput, setFormInput] = useState(formArray);

  useEffect(() => {
    setFormInput(formArray);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errors]);

  return (
    <FormGenerator
      children={formInput}
      submitURL={api_url.organisation}
      handleNext={props.handleNext}
      nextIndex={2}
      setId={props.setId}
    />
  );
}
